import type { Federation } from "@/models/Federation";

/**
 * Resolves a federation's display name from its NHO number using the federation
 * list (FederationHub is the master for names, so blocks only store the number).
 * Returns an empty string when the list is not loaded yet or the number is
 * unknown.
 */
export function getFederationNameByNumber(
  associations: Array<Federation> | undefined,
  nhoNumber: number
): string {
  if (!associations) {
    return "";
  }
  const match = associations.find((org) => org.nhoNumber === nhoNumber);
  return match ? match.name : "";
}
